"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Utils = void 0;
var IllegalArgumentException_1 = require("../Exceptions/IllegalArgumentException");
var TextUtils_1 = require("./TextUtils");
var Utils = /** @class */ (function () {
    function Utils() {
    }
    Utils.isDebuggable = function (m_context) {
        return false;
    };
    Utils.DebugLog = function (tag, text) {
    };
    Utils.formatKey = function (nodeName, defaultAttr, defaultAttrValue) {
        return "##" + nodeName + "##" + defaultAttr + "##" + defaultAttrValue + "##";
    };
    Utils.CheckNullParameters = function (sFunctionName) {
        var FunctionParams = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            FunctionParams[_i - 1] = arguments[_i];
        }
        if (FunctionParams == null) {
            throw new IllegalArgumentException_1.default("Error de ejecución. Faltan parámetros para '" + sFunctionName + "'");
        }
    };
    Utils.CheckIncorrectParamCount = function (sFunctionName, FunctionParams, nExpectedCount) {
        if (FunctionParams == null) {
            if (nExpectedCount == 0) {
                return;
            }
            throw new IllegalArgumentException_1.default("Error de ejecución. Número incorrecto de parámetros para '" + sFunctionName + "'");
        }
        if (FunctionParams.length != nExpectedCount) {
            throw new IllegalArgumentException_1.default("Error de ejecución. Número incorrecto de parámetros para '" + sFunctionName + "'");
        }
    };
    Utils.CheckIncorrectParamRange = function (sFunctionName, FunctionParams, nMinimumParameterCount, nMaximumParameterCount) {
        if (FunctionParams == null) {
            if (nMinimumParameterCount == 0) {
                return;
            }
            throw new IllegalArgumentException_1.default("Error de ejecución. Número incorrecto de parámetros para '" + sFunctionName + "'");
        }
        if (FunctionParams.length < nMinimumParameterCount) {
            throw new IllegalArgumentException_1.default("Error de ejecución. Número incorrecto de parámetros para '" + sFunctionName + "'");
        }
        if (FunctionParams.length > nMaximumParameterCount && nMaximumParameterCount != -1) {
            throw new IllegalArgumentException_1.default("Error de ejecución. Número incorrecto de parámetros para '" + sFunctionName + "'");
        }
    };
    Utils.setLastAppExecutedField = function (m_context, sUserName, arg2) {
        // TODO: Luis buscar un mecanismo para persistir datos en el navegador
    };
    Utils.getThrowableMessage = function (t) {
        if (t == null) {
            return Utils.EMPTY_STRING;
        }
        var sExceptionMessage = t.getClass().getSimpleName();
        var sMessage = t.getMessage();
        if (!TextUtils_1.default.isEmpty(sMessage)) {
            sExceptionMessage = sExceptionMessage + "(): " + sMessage;
        }
        return sExceptionMessage;
    };
    Utils.DEFAULT_BGCOLOR = "#FFB22C1B";
    Utils.DEFAULT_FORECOLOR = "#FF000000";
    Utils.FAIL_EXITAPP = "##EXITAPP##";
    Utils.FAIL_EXIT = "##EXIT##";
    Utils.FAIL_LOGIN = "##LOGIN_START##";
    Utils.MACRO_LOGIN_START = Utils.FAIL_LOGIN;
    Utils.MACRO_LOGIN_USERCOLL = "##LOGIN_USERCOLL##";
    Utils.MACRO_LOGIN_NEWUSER = "##LOGIN_NEWUSER##";
    Utils.MACRO_LOGIN_NEWPASS = "##LOGIN_NEWPASS##";
    Utils.MACRO_LOGIN_COLL_OBJECT_INDEX = "##LOGIN_COLL_OBJECT_INDEX##";
    Utils.MACRO_STARTREPLICA = "##STARTREPLICA##";
    Utils.TAG_DATABASE_LOG = "XOneDatabase";
    Utils.PROP_ATTR_EMBED = "embed";
    // Valores por defecto
    Utils.PROP_DEFAULT_FIELDSIZE = 14;
    Utils.PROP_DEFAULT_LABELWIDTH = 10;
    Utils.PROP_DEFAULT_CONTENTLINES = 10;
    Utils.TRUE_VALUE = "true";
    Utils.FALSE_VALUE = "false";
    Utils.DEFAUT_FILES_PATH = "files/";
    Utils.DATE_SEPARATOR = "/";
    Utils.HOUR_SEPARATOR = ":";
    Utils.DANISH_HOUR_SEPARATOR = "\\.";
    // Valores para los lastexcuted app
    Utils.LAST_EXECUTED_APP_FILE_NAME = "lastexecuted.ini";
    Utils.LAST_EXECUTED_APP_FIELD_NAME = "appname";
    Utils.LAST_EXECUTED_USER_FIELD_NAME = "user";
    Utils.LICENSE_FIELD_NAME = "License";
    Utils.SERVER_FIELD_NAME = "ServerADDR";
    Utils.TAG_FRAMEWORK = "XOneFramewrok";
    Utils.TAG_MAPPINGFILE = "mappings";
    Utils.TAG_APPNODE = "app.xml";
    Utils.EMPTY_STRING = "";
    Utils.PROP_NAME = "prop";
    Utils.PROP_ATTR_FRAME = "frame";
    Utils.PROP_ATTR_CONTENTNAME = "contents";
    Utils.PROP_ATTR_GROUP = "group";
    Utils.PROP_ATTR_NAME = "name";
    Utils.PROP_ATTR_VISIBLE = "visible";
    Utils.PROP_ATTR_TITLE = "title";
    Utils.PROP_ATTR_INDEX = "index";
    Utils.PROP_ATTR_TYPE = "type";
    // Mascaras de bits
    Utils.MASK_EDIT_VISIBLE = 1;
    Utils.MASK_LIST_VISIBLE = 2;
    Utils.MASK_CONTENT_VISIBLE = 4;
    Utils.MASK_DROPDOWN_VISIBLE = 8;
    // Macros
    Utils.MACRO_DEFAULT = "##DEFAULT##";
    Utils.MACRO_TAG = "##";
    // Cadenas de la colección
    Utils.COLL_COLLPROPS = "collprops";
    Utils.COLL_COLL = "coll";
    Utils.COLL_LOGIN_COLL = "login-coll";
    Utils.COLL_LOGOFF_COLL = "logoff-coll";
    Utils.PLATFORM_NAME = "platform";
    return Utils;
}());
exports.Utils = Utils;

//# sourceMappingURL=Utils.js.map
